import Cookies from 'js-cookie';

const app = {
  state: {
    themeColor: '#FE5924',
    themeGreen: '#41B883',
    language: Cookies.get('language') || 'zh_CN',
    sidebar: {
      opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
      withoutAnimation: false
    },
    device: 'desktop',
    realMobile: false,
    breadTitle: '',
    integralFeatureFlag: true,// 积分功能是否打开
    Privacy: 'https://maxain-bucket-prod.s3-accelerate.amazonaws.com/files/PrivacyPolicy.pdf',
    RiskStatement: 'https://maxain-bucket-prod.s3-accelerate.amazonaws.com/files/RiskDisclosureandWarningNotice.pdf',
    ToPreventMoneyLaundering: 'https://maxain-bucket-prod.s3-accelerate.amazonaws.com/files/AntiMoneyLaunderingAgreement.pdf',
    safety_instructions: 'https://maxain-bucket-prod.s3-accelerate.amazonaws.com/files/AccountFundsSecurityStatement.pdf',
    listRefresh: false,// 列表刷新
    websiteDomain: '',// worldpress官网,

    openAccountRole: '',// MAM主账户是4,MAM投资账户是5
  },
  mutations: {
    SET_LANGUAGE: (state, language) => {
      state.language = language;
      Cookies.set('language', language,{ expires: 7 });
    },
    TOGGLE_SIDEBAR: state => {
      state.sidebar.opened = !state.sidebar.opened;
      state.sidebar.withoutAnimation = false;
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 1)
      } else {
        Cookies.set('sidebarStatus', 0)
      }
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      Cookies.set('sidebarStatus', 0);
      state.sidebar.opened = false;
      state.sidebar.withoutAnimation = withoutAnimation;
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device;
    },
    setMenuTitle: (state, title) => {
      state.breadTitle = title;
    },
    setRealMobile: (state, flag) => {
      state.realMobile = flag;
    },
    setListRefresh: (state, flag) => {
      state.listRefresh = flag;
    },
    setWebsiteDomain: (state, websiteDomain) => {
      state.websiteDomain = websiteDomain;
    },
    setIntegralFeatureFlag: (state, integralFeatureFlag) => {
      state.integralFeatureFlag = integralFeatureFlag;
    },
    setOpenAccountRole: (state, openAccountRole) => {
      state.openAccountRole = openAccountRole;
    },
  },
  actions: {
    setLanguage({ commit }, language) {
      commit('SET_LANGUAGE', language);
    },
    toggleSideBar({ commit }) {
      commit('TOGGLE_SIDEBAR')
    },
    closeSideBar({ commit }, { withoutAnimation }) {
      commit('CLOSE_SIDEBAR', withoutAnimation)
    },
    toggleDevice({ commit }, device) {
      commit('TOGGLE_DEVICE', device)
    }
  },
  getters:{
    language: state => state.language,
    sidebar: state => state.sidebar,
    device: state => state.device,
    breadTitle: state => state.breadTitle,
    Privacy: state => state.Privacy,
    RiskStatement: state => state.RiskStatement,
    ToPreventMoneyLaundering: state => state.ToPreventMoneyLaundering,
    safety_instructions: state => state.safety_instructions,

    realMobile: state => state.realMobile,
    listRefresh: state => state.listRefresh,
    websiteDomain: state => state.websiteDomain,
    themeColor: state => state.themeColor,
    themeGreen: state => state.themeGreen,
    integralFeatureFlag: state => state.integralFeatureFlag,
    openAccountRole: state => state.openAccountRole,
  }
};

export default app;
